import { MessageNode, MessageContent } from '@/types/message'
import { Renderer } from './renderer'
import { useState } from 'react'

interface RenderContainerProps {
  nodeList: MessageNode[]
  useTypingComplete: boolean
  msgContent: MessageContent
  style?: React.CSSProperties
  onMount?: () => void
  onTypingComplete?: () => void
}

const RenderContainer = (props: RenderContainerProps) => {
  const { nodeList, useTypingComplete, msgContent, style, onMount, onTypingComplete } = props
  const isEnd = props.msgContent.placement === 'end'
  const [renderIndex, setRenderIndex] = useState(0)

  const onTypingCompleteOrMount = (opt: {
    index: number
    nextIndex: number
    type: 'typing' | 'mount'
  }) => {
    const idx = opt.index + 1
    if (idx < nodeList.length) {
      setRenderIndex(opt.nextIndex)
    } else {
      onTypingComplete?.()
      onMount?.()
    }
  }

  return (
    <div style={{ ...style }}>
      {nodeList?.map?.((node, index) => {
        if (renderIndex < index && useTypingComplete) {
          return null
        }

        return (
          <>
            <Renderer
              useTypingComplete={useTypingComplete}
              onMount={() => {
                //如果是右侧的消息，无需走打字机渲染效果,调用onTypingCompleteOrMount函数是直接不计算渲染时间
                if (isEnd) {
                  onTypingCompleteOrMount({
                    index: index,
                    nextIndex: index + 1,
                    type: 'mount'
                  })
                }
                //如果是非文本类型，也无需走打字机效果,通过onMount函数来计算所有节点的渲染完成结束时间
                if (!['text', 'link', 'markdown'].includes(node.type)) {
                  onTypingCompleteOrMount({
                    index: index,
                    nextIndex: index + 1,
                    type: 'mount'
                  })
                }
              }}
              onTypingComplete={() => {
                if (isEnd) return
                if (!useTypingComplete) return
                onTypingCompleteOrMount({
                  index: index,
                  nextIndex: index + 1,
                  type: 'typing'
                })
              }}
              msgNode={node}
              msgContent={msgContent}
            />
          </>
        )
      })}
    </div>
  )
}
export default RenderContainer
